export default __webpack_public_path__ + "static/media/xlsx.6393ba34.svg";